import { render, staticRenderFns } from "./CreateYourWillBanner.vue?vue&type=template&id=bcf79f7e&scoped=true"
import script from "./CreateYourWillBanner.vue?vue&type=script&lang=js"
export * from "./CreateYourWillBanner.vue?vue&type=script&lang=js"
import style0 from "./CreateYourWillBanner.vue?vue&type=style&index=0&id=bcf79f7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf79f7e",
  null
  
)

export default component.exports